<div class="pl-pane__container--horizontal pl-pane--full-screen">
  <app-nav-bar route="/user/registrations"></app-nav-bar>

  @if (order) {
    <section class="pl-pane__header">
      <div pl-grid="1/1@phone" pl-grid-el>
        <div pl-grid="loose">
          <div pl-grid="1/1@phone grow@tablet" pl-grid-el>
            <h2 class="pl-heading--xlarge">
              <span [textContent]="'SALE_DETAIL.HEADERS.sale' | translate: { sale_number: order.sale_number }"></span>
              <span [class]="statusTagColor(order)">{{ 'SALE_DETAIL.STATUSES.' + order.display_status | translate }}</span>
            </h2>
            <div pl-grid="1/1@phone grow@tablet" pl-grid-el>
              <p>
                @if (order.user_full_name) {
                  <span [textContent]="order.user_full_name"></span>
                }
                @if (!order.user_full_name) {
                  <span [textContent]="'ORDER_DETAIL.SUBTITLE.anonymous_user' | translate"></span>
                  }'s
                  <span [textContent]="'SALE_DETAIL.SUBTITLE.order_description' | translate"></span>
                  <span [textContent]="order.store_name"></span>
                </p>
              </div>
            </div>
            @if (showMakePaymentButton) {
              <div
                pl-grid="grow@phone" pl-grid-el
                class="pl-text--right">
                <se-fe-button seFeDataEmphasis="high" (click)="makePayment()">
                  <span>{{'SALE_DETAIL.BUTTONS.make_a_payment' | translate}}</span>
                </se-fe-button>
              </div>
            }
          </div>
        </div>
      </section>
    }

    @if (order) {
      <section class="pl-pane__info pl-layout--on-gray">
        <div class="pl-centered-container--max-width">
          <div pl-grid="loose">
            <div pl-grid-el pl-grid="1/1@phone 2/3@tablet">
              <div pl-grid="loose">
                <div pl-grid-el pl-grid="1/1@phone">
                  <app-sale-info-card
                    [sale]="order"
                    [activity]="activity">
                  </app-sale-info-card>
                </div>
                @if (payments) {
                  <div pl-grid-el pl-grid="1/1@phone">
                    <app-payment-plan
                      [sale]="order"
                      [payments]="payments">
                    </app-payment-plan>
                  </div>
                }
                <div pl-grid-el pl-grid="1/1@phone">
                  @if (activity) {
                    <app-sale-activity-card
                      [sale]="order"
                      [activity]="activity">
                    </app-sale-activity-card>
                  }
                </div>
              </div>
            </div>
            <div pl-grid-el pl-grid="1/1@phone 1/3@tablet">
              @if (order.parent_sale || order.child_sales?.length > 0) {
                <se-po-related-orders-card
                  [order]="order"
                  [type]="'order'">
                </se-po-related-orders-card>
              }
            </div>
          </div>
        </div>
      </section>
    }
  </div>
